import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(apiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-gradient-to-br from-primary/10 via-background to-blue-500/10 px-4">
      <Card className="w-full max-w-md p-8 space-y-6 shadow-xl">
        <h1 className="text-2xl font-bold font-display text-center">Reset password</h1>
        {sent ? (
          <div className="text-center space-y-4" data-testid="forgot-confirm">
            <p className="text-sm text-muted-foreground">If that email is registered, a reset link has been sent. Please check your inbox.</p>
            <Link to="/admin" className="text-primary hover:underline text-sm">← Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <Label>Email</Label>
              <Input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            {error && <p className="text-sm text-destructive">{error}</p>}
            <Button type="submit" className="w-full" data-testid="forgot-submit" disabled={loading}>
              {loading ? "Sending..." : "Send reset link"}
            </Button>
            <Link to="/admin" className="block text-center text-sm text-muted-foreground hover:underline">← Back to sign in</Link>
          </form>
        )}
      </Card>
    </div>
  );
}
